"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personalGeneralSettings = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxAct = require("redux-act");

var actions = _interopRequireWildcard(require("./personalGeneralSettings.actions"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  isLoading: false,
  isLoaded: false,
  errors: {},
  avatarUrl: '',
  firstName: '',
  lastName: '',
  phone: '',
  role: '',
  funFacts: '',
  showFunFacts: false
};
exports.initialState = initialState;
var personalGeneralSettings = (0, _reduxAct.createReducer)({}, initialState).on(actions.getSettings, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true,
    isLoaded: false
  });
}).on(actions.getSettingsSuccess, function (state, payload) {
  var _payload$avatarUrl = payload.avatarUrl,
      avatarUrl = _payload$avatarUrl === void 0 ? '' : _payload$avatarUrl,
      _payload$firstName = payload.firstName,
      firstName = _payload$firstName === void 0 ? '' : _payload$firstName,
      _payload$lastName = payload.lastName,
      lastName = _payload$lastName === void 0 ? '' : _payload$lastName,
      _payload$phone = payload.phone,
      phone = _payload$phone === void 0 ? '' : _payload$phone,
      _payload$role = payload.role,
      role = _payload$role === void 0 ? '' : _payload$role,
      _payload$funFacts = payload.funFacts,
      funFacts = _payload$funFacts === void 0 ? '' : _payload$funFacts,
      _payload$showFunFacts = payload.showFunFacts,
      showFunFacts = _payload$showFunFacts === void 0 ? false : _payload$showFunFacts;
  return {
    isLoading: false,
    isLoaded: true,
    avatarUrl,
    firstName,
    lastName,
    phone,
    role,
    funFacts,
    showFunFacts,
    errors: {}
  };
}).on(actions.getSettingsFail, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    errors: payload
  });
}).on(actions.deleteAvatarSuccess, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    avatarUrl: payload
  });
}).on(actions.setAvatarSuccess, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    avatarUrl: payload,
    errors: {}
  });
}).on(actions.setPhoneSuccess, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    phone: payload,
    errors: {}
  });
}).on(actions.setNameSuccess, function (state, payload) {
  var firstName = payload.firstName,
      lastName = payload.lastName;
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    firstName,
    lastName,
    errors: {}
  });
}).on(actions.setRoleSuccess, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    role: payload,
    errors: {}
  });
}).on(actions.setFunFactsSuccess, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    funcFacts: payload.funFacts,
    showFunFacts: payload.showFunFacts,
    errors: {}
  });
});
exports.personalGeneralSettings = personalGeneralSettings;
[actions.setAvatar, actions.deleteAvatar, actions.setFunFacts, actions.setRole, actions.setName, actions.setPhone].forEach(function (action) {
  return personalGeneralSettings.on(action, function (state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isLoading: true
    });
  });
});
[actions.setFunFactsFail, actions.setRoleFail, actions.setNameFail, actions.setPhoneFail, actions.setAvatarFail, actions.deleteAvatarFail].forEach(function (action) {
  return personalGeneralSettings.on(action, function (state, payload) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isLoading: false,
      errors: payload
    });
  });
});